import React from "react";
import styles from "./refund.module.scss";
import { Heading, Link, Text } from "@radix-ui/themes";

const Refund: React.FC = () => (
  <div className={`container ${styles.refundContainer}`}>
    <Heading as="h1" color="blue">
      Refund and Cancellation Policy
    </Heading>
    <Text as="p">
      You can cancel bus tickets online, Most of the tickets can be canceled
      online. However, there are some bus tickets that can only be cancelled by
      sending email to <Link href="mailto:admin@quickbusride.in">admin@quickbusride.in</Link>.However please note that the
      cancellation fee and cancellation period may differ for specific bus
      services.
    </Text>
    <Text as="p">
      The refund is provided as per the cancellation policy of the operator. The
      refund can be credited to the source of payment (Example: debit card,
      credit card, net banking).
    </Text>
    <Text as="p">
      If your bus does not leave on time or is canceled, in such situations, you
      will need to consult the counter of the respective bus operators.
    </Text>
  </div>
);

export default Refund;
